import { useState, useCallback, useMemo } from "react";
import AddressField from "./AddressField";
import { ADDRESS_FORM_CONFIG } from "@/components/AddressFields/addressFormConfig";
import { useValidationEngine } from "@/components/AddressFields/useValidationEngine";
import { useAsyncValidation } from "@/components/AddressFields/useAsyncValidation";

const AddressForm = ({ initialData, onSubmit, otpHandlers, editAddressForm }) => {
  const [formData, setFormData] = useState(initialData);
  const [otpState, setOtpState] = useState({});

  const { validatePincode } = useAsyncValidation(setFormData);

  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));

    if (name === "pincode") {
      validatePincode(value);
    }
  }, [validatePincode]);

  const { errors, isValid } = useValidationEngine(
    ADDRESS_FORM_CONFIG,
    formData,
    otpState
  );

  const context = useMemo(
    () => ({ formData, otpState, setOtpState, otpHandlers }),
    [formData, otpState, otpHandlers]
  );

  return (
    <div className="flex flex-col h-full">
      {/* ================= SCROLLABLE FORM CONTENT ================= */}
      <div className="flex-1 overflow-y-auto pb-32 md:pb-0">
        {ADDRESS_FORM_CONFIG.map((section) => (
          <section key={section.section} className="p-4">
            <h3 className="text-sm font-medium mb-3">
              {section.section}
            </h3>

            <div className="flex flex-col gap-3">
              {section.fields.map((field) => (
                <AddressField
                  key={field.key}
                  field={field}
                  value={formData[field.key]}
                  onChange={handleChange}
                  error={errors[field.key]}
                  context={context}
                />
              ))}
            </div>
          </section>
        ))}
      </div>

      {/* ================= DESKTOP FOOTER ================= */}
      <div className="hidden md:block p-4 border-t">
        <button
          disabled={!isValid}
          onClick={() =>
            onSubmit({
              ...formData,
              editAddressId: editAddressForm?._id
            })
          }
          className="w-full py-3 rounded-lg text-white bg-BluntRed disabled:bg-gray-300"
        >
          SAVE ADDRESS
        </button>
      </div>

      {/* ================= MOBILE / TABLET STICKY FOOTER ================= */}
      <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t p-4 z-50">
        <button
          disabled={!isValid}
          onClick={() =>
            onSubmit({
              ...formData,
              editAddressId: editAddressForm?._id
            })
          }
          className="w-full py-3 rounded-lg text-white bg-BluntRed disabled:bg-gray-300"
        >
          SAVE ADDRESS
        </button>
      </div>
    </div>
  );
};

export default AddressForm;
